export enum ImpersonationKind {
  LINKED = "linked",
  SUPPORT = "support",
}
